import type {RutaProd} from '../../../../runtime/rutas';
export default {
  "ruta": "/sistema/store/finalize",
  "alias": [],
  "documento": "pos-store",
  "acceso": "sesion",
  "filas": [
    "048"
  ],
  "cita": "Areas/POS_Store/Controllers/OrdersController.cs"
} satisfies RutaProd;
